import { openErrorModal } from '../../actions';
import { getCroppedImg } from '../../utils/image';
import { ERROR_ADDING_IMAGE } from '../../constants';

export const onCropChange = (crop, component) => {
  component.setState({ crop });
};

export const onZoomChange = (zoom, component) => {
  component.setState({ zoom });
};
export const onChangePicture = (picture, component) => {
  component.setState({ picture, cropSize: null, zoom: 1, crop: { x: 0, y: 0 } });
};
export const onCropComplete = async (_, croppedAreaPixels, component) => {
  const { setCroppedImage, fileType } = component.props;
  const { picture } = component.state;

  try {
    const croppedImageUrl = await getCroppedImg(picture[0].imageUrl, croppedAreaPixels, fileType);

    setCroppedImage(croppedImageUrl);
  } catch (e) {
    openErrorModal(ERROR_ADDING_IMAGE);
  }
};
